<div class="container">
  @if (recipes.length) {
    <div>
      @for (recipe of recipes; track recipe) {
        <recipe [recipe]="recipe" [integrationType]="integrationType"></recipe>
      }
    </div>
  } @else {
    <div class="empty-state">
      <img draggable="false" src="/assets/images/empty_state.svg" />
      <div class="empty-state__bottom">
        <p class="empty-state__bottom__text">No recipes</p>
        <div class="empty-state__bottom__action">
          Try a <pdq-link (onClick)="onTryTemplateClick.emit()" label="Recipe template"></pdq-link>
        </div>
      </div>
    </div>
  }
</div>
